import styled from 'styled-components'
import { COLOR, FONT } from '@farewill/ui/tokens'

import Tooltip from 'components/tooltip'

const StyledScore = styled.div`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  color: ${COLOR.GREY.DARK};
  background: ${COLOR.GREY.LIGHT};
  font-size: ${FONT.SIZE.XXS};
  font-weight: ${FONT.WEIGHT.BOLD};
`

type Props = {
  conversionScore?: number | null
  /** What the score means, shown on hover. No tooltip when left out. */
  description?: string
}

const ConversionScoreIcon = ({
  conversionScore,
  description,
}: Props): React.ReactElement | null => {
  if (!conversionScore) return null

  const score = <StyledScore>{conversionScore}</StyledScore>

  return description ? (
    <Tooltip content={description} underlined={false}>
      {score}
    </Tooltip>
  ) : (
    score
  )
}

export default ConversionScoreIcon
